// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__6N1Dz","checkboxCol":"Table_checkboxCol__1UP-y","emailCol":"Table_emailCol__2VfBM","actionCol":"Table_actionCol__7xU7z"};